import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TFAState } from './state';

const selectTFAState = createFeatureSelector<TFAState>('TFA');

export const selectTFAStatus = createSelector(selectTFAState, (store: TFAState) => store.TFAStatus);
export const selectTFAStatusLoaded = createSelector(selectTFAState, (store: TFAState) => store.TFAStatusLoaded);
export const selectTFAStatusLoading = createSelector(selectTFAState, (store: TFAState) => store.TFAStatusLoading);
